import { useEffect, useLayoutEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Invitation } from "@/components/site/Invitation";
import { Inside } from "@/components/site/Inside";
import { Philosophy } from "@/components/site/Philosophy";
import { PlansSection } from "@/components/site/PlansSection";
import { Faq } from "@/components/site/Faq";
import { Founders } from "@/components/site/Founders";
import { FireflyCursor } from "@/components/site/FireflyCursor";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Admin from "@/pages/Admin";
import Labels from "@/pages/Labels";
import PlanDetails from "@/pages/PlanDetails";
import { Footer } from "@/components/site/Footer";
import { usePageMeta } from "@/lib/meta";

const Home = () => {
  const { hash } = useLocation();
  usePageMeta(null, "/");
  useEffect(() => {
    if (hash) setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 50);
  }, [hash]);

  return (
    <div className="App bg-white paper-grain min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Invitation />
        <Inside />
        <Philosophy />
        <PlansSection />
        <Faq />
        <Founders />
      </main>
      <Footer />
    </div>
  );
};

const ScrollReset = () => {
  const { pathname, hash } = useLocation();
  useLayoutEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollReset />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/plans/:slug" element={<PlanDetails />} />
        <Route path="/plans" element={<Navigate to="/#pricing" replace />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/labels" element={<Labels />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <FireflyCursor />
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
